import React from 'react';
import banners from '../../../image/Banner3.jpg'

const Banner = () => {
    return (
        <div>
            <img src={banners} class="img-fluid" alt="" srcset="" />
        </div>
    );
};

export default Banner;